import * as yup from 'yup';

export const getValidationSchema = (page: string, sleeper: number) => {
  const validateSelectedSleeper = (value: any, context: any) => {
    const stringValidationSchema = yup.string().required();
    const currentIndex = parseInt(context.options.index);

    if (currentIndex === sleeper) {
      if (!stringValidationSchema.isValidSync(value)) {
        return false;
      }
    }

    return true;
  };

  const schema = {
    sleepers: yup.object({
      noSleepers: yup.string().required('Please select a value').typeError('Please select a value'),
    }),
    mattressSize: yup.object({
      mattressSize: yup.string().required('Please select a value').typeError('Please select a value'),
    }),

    sharedSleepGoal: yup.object({
      sharedSleepGoal: yup.string().required('Please select a shared sleep goal').typeError('Please select a value'),
    }),
    name: yup.object({
      sleeper: yup.array().of(
        yup.object().shape({
          name: yup.string().test({
            name: 'checkNameSleeper',
            message: 'Please enter your name',
            test: (item, context) => validateSelectedSleeper(item, context),
          }),
        })
      ),
    }),
    weight: yup.object({
      sleeper: yup.array().of(
        yup.object().shape({
          weight: yup.string().test({
            name: 'checkWeight',
            message: 'Please select a weight value',
            test: (item, context) => validateSelectedSleeper(item, context),
          }),
        })
      ),
    }),
    height: yup.object({
      sleeper: yup.array().of(
        yup.object().shape({
          height: yup.string().test({
            name: 'checkHeight',
            message: 'Please select a height value',
            test: (item, context) => validateSelectedSleeper(item, context),
          }),
        })
      ),
    }),
    waist: yup.object({
      sleeper: yup.array().of(
        yup.object().shape({
          waist: yup.string().test({
            name: 'checkwait',
            message: 'Please select a waist value',
            test: (item, context) => validateSelectedSleeper(item, context),
          }),
        })
      ),
    }),
    sleepPosition: yup.object({
      sleeper: yup.array().of(
        yup.object().shape({
          sleepPosition: yup.string().test({
            name: 'checkSleepPosition',
            message: 'Please select a sleep position',
            test: (item, context) => validateSelectedSleeper(item, context),
          }),
        })
      ),
    }),
    sleepGoal: yup.object({
      sleeper: yup.array().of(
        yup.object().shape({
          sleepGoal: yup.string().test({
            name: 'checkSleepGoal',
            message: 'Please select a sleep goal',
            test: (item, context) => validateSelectedSleeper(item, context),
          }),
        })
      ),
    }),
  };

  return schema[page as keyof typeof schema];
};
